<template lang="pug">
v-data-table.elevation-2.mt-4(:headers='headers', :items='codes' :loading='isLoading' loading-text="Loading... Please wait")
  template(v-slot:top='')
    v-toolbar(flat='', color='white')
      v-toolbar-title Promo codes
      v-spacer
      v-dialog(v-model='dialog', max-width='800')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary', dark='', v-on='on') Add code
        v-card
          v-card-title
            span.headline {{ formTitle }}
          v-card-text
            v-container
              v-row
                v-col(md='12')
                  v-text-field(v-model='editedItem.name', label='Name' outlined hide-details)
                v-col(md='8')
                  v-text-field(v-model='editedItem.percent' outlined='' label='Percent')
                v-col(md='4')
                  v-checkbox(v-model='editedItem.delete_after_usage', label='Delete after usage' hide-details)
          v-card-actions
            v-spacer
            v-btn(color='primary', text='', @click='close') Cancel
            v-btn(color='primary', text='', @click='save') Save
  template(v-slot:item.actions='{ item }')
    v-icon.mr-2(small='', @click='editItem(item)')
      | mdi-pencil
    v-icon(small='', @click='deleteItem(item)')
      | mdi-delete
  template(v-slot:item.name='{ value }')
    span {{value.length>20?value.substring(0,20)+"...":value}}
  template(v-slot:item.delete_after_usage='{ value }')
    v-checkbox(disabled, v-model='value')
</template>
<script>
  export default {
    data: () => ({
      dialog: false,
      isLoading: false,
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Delete after usage', value: 'delete_after_usage' },
        { text: 'Percent', value: 'percent' },
        { text: 'Used', value: 'used_times' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      codes: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        delete_after_usage: false,
        percent: 0,
      },
      defaultItem: {
        name: '',
        delete_after_usage: false,
        percent: 0,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.refreshCodes()
    },
    methods: {
      refreshCodes() {
        this.isLoading = true
        this.axios.get("/admin/promo").then(resp => {
          this.codes = resp.data
        }).catch(e => {
          this.$message.errorFromServer(e)
        }).finally(() => this.isLoading = false)
      },

      editItem (item) {
        this.editedIndex = this.codes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.codes.indexOf(item)
        if (confirm('Are you sure you want to delete this item?')){
          this.codes.splice(index, 1)
          this.axios.delete('/documents/template/' + item.ID)
        }
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          this.editedItem.percent = parseInt(this.editedItem.percent)
          this.$set(this.codes, this.editedIndex, this.editedItem)
          var newItem = Object.assign({}, this.codes[this.editedIndex])
          delete newItem.UpdatedAt
          delete newItem.CreatedAt
          delete newItem.DeletedAt
          this.axios.put('/admin/promo', newItem)
          
        } else {
          this.editedItem.percent = parseInt(this.editedItem.percent)
          this.codes.push(this.editedItem)
          this.axios.post('/admin/promo', this.editedItem)
        }
        this.close()
      },
    },
  }
</script>